<style scoped>
.v-application .text-h4 {
  font-family: "Prompt", sans-serif !important;
  font-size: 24px !important;
}
.text-spacing {
  letter-spacing: 0px !important;
}
.v-application .white {
  border: #ccd0d9 solid 1px !important;
}
</style>

<template>
  <div>
    <v-layout class="d-flex justify-space-between">
      <div
        class="text-h4 font-weight-black primary--text text-spacing"
        color="blue"
      >
        ข้อมูลรถเก็บขน
      </div>
      <v-spacer></v-spacer>

      <v-btn color="success" elevation="0" dark link :to="'/manage/add-Car'">
        <v-icon left>mdi-file-plus</v-icon>เพิ่มรถเก็บขน
      </v-btn>
    </v-layout>
    <v-divider class="my-2"></v-divider>
    <!-- <v-toolbar dense short>
      <v-spacer></v-spacer>
      <v-menu offset-y :position-x="100" :nudge-width="500" :close-on-content-click="false">
        <template v-slot:activator="{ on, attrs }">
          <v-btn color="info" v-bind="attrs" v-on="on">
            <v-icon>mdi-magnify</v-icon>ค้นหา
          </v-btn>
        </template>
        <v-card>
          <v-list>
            <v-list-item>
              <v-list-item-avatar>
                <img src="https://cdn.vuetifyjs.com/images/john.jpg" alt="John" />
              </v-list-item-avatar>

              <v-list-item-content>
                <v-list-item-title>John Leider</v-list-item-title>
                <v-list-item-subtitle>Founder of Vuetify.js</v-list-item-subtitle>
              </v-list-item-content>

              <v-list-item-action>
                <v-btn :class="fav ? 'red--text' : ''" icon @click="fav = !fav">
                  <v-icon>mdi-heart</v-icon>
                </v-btn>
              </v-list-item-action>
            </v-list-item>
          </v-list>

          <v-divider></v-divider>

          <v-list>
            <v-list-item>
              <v-list-item-action>
                <v-switch v-model="message" color="purple"></v-switch>
              </v-list-item-action>
              <v-list-item-title>Enable messages</v-list-item-title>
            </v-list-item>

            <v-list-item>
              <v-list-item-action>
                <v-switch v-model="hints" color="purple"></v-switch>
              </v-list-item-action>
              <v-list-item-title>Enable hints</v-list-item-title>
            </v-list-item>
          </v-list>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn text @click="menu = false">Cancel</v-btn>
            <v-btn color="primary" text @click="menu = false">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-menu>
    </v-toolbar>-->
    <v-layout v-resize="onResize" column class="pt-5">
      <v-data-table :headers="headers" :items="desserts" :search="search">
        <template slot="items" slot-scope="props">
          <tr v-if="!isMobile">
            <td>{{ props.item.name }}</td>
            <td class="text-xs-right">{{ props.item.calories }}</td>
            <td class="text-xs-right">{{ props.item.fat }}</td>
            <td class="text-xs-right">{{ props.item.carbs }}</td>
            <td class="text-xs-right">{{ props.item.protein }}</td>
            <td class="text-xs-right">{{ props.item.iron }}</td>
          </tr>
          <tr v-else>
            <td>
              <ul class="flex-content">
                <li class="flex-item" data-label="Name">
                  {{ props.item.name }}
                </li>
                <li class="flex-item" data-label="Calories">
                  {{ props.item.calories }}
                </li>
                <li class="flex-item" data-label="Fat (g)">
                  {{ props.item.fat }}
                </li>
                <li class="flex-item" data-label="Carbs (g)">
                  {{ props.item.carbs }}
                </li>
                <li class="flex-item" data-label="Protein (g)">
                  {{ props.item.protein }}
                </li>
                <li class="flex-item" data-label="Iron (%)">
                  {{ props.item.iron }}
                </li>
              </ul>
            </td>
          </tr>
        </template>
        <template v-slot:item.edit="{ item }">
          <v-btn
            color="info"
            small
            class="mb-0 font-weight-bold"
            @click="edit_carrier(item)"
          >
            <v-icon left>mdi-file-document-edit-outline</v-icon>แก้ไข
          </v-btn>
        </template>
        <template v-slot:item.delete="{ item }">
          <v-btn
            color="warning"
            small
            class="mb-0 font-weight-bold"
            @click="delete_carrier(item)"
          >
            <v-icon left>mdi-trash-can-outline</v-icon>ลบ
          </v-btn>
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <TableMenuCustomer
            :TableData="item"
            :whichPage="'car_Edit'"
            v-on:myCarEvent="initialize"
          ></TableMenuCustomer>
        </template>
        <template v-slot:no-data>
          <v-btn color="info" @click="initialize">
            <v-icon left>mdi-refresh</v-icon>รีเฟรชข้อมูล
          </v-btn>
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning"
          >Your search for "{{ search }}" found no results.</v-alert
        >
      </v-data-table>
    </v-layout>
  </div>
</template>

<script>
import TableMenuCustomer from "../components/TableMenuCustomer";

export default {
  components: {
    TableMenuCustomer,
  },
  data: () => ({
    fav: true,
    menu: false,
    message: false,
    hints: true,
    pagination: {
      sortBy: "name",
    },
    selected: [],
    search: "",
    isMobile: false,
    headers: [
      {
        text: "เลขทะเบียน",
        align: "start",
        sortable: true,
        value: "CAR_NUMBER",
      },
      { text: "ประเภท", value: "CAR_TYPE" },
      { text: "ยี่ห้อ", value: "CAR_BRAND" },
      { text: "รุ่น", value: "CAR_GENERATION" },
      // { text: "แก้ไข", value: "edit", width: "10%" },
      // { text: "ลบ", value: "delete", width: "10%" },
      { text: "จัดการข้อมูล", value: "actions" },
    ],
    desserts: [],
  }),
  created() {
    this.listCar();
    this.$store.dispatch("Carrier/car_reset");
  },
  methods: {
    onResize() {
      if (window.innerWidth < 769) this.isMobile = true;
      else this.isMobile = false;
    },
    toggleAll() {
      if (this.selected.length) this.selected = [];
      else this.selected = this.desserts.slice();
    },
    changeSort(column) {
      // console.log(column);
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
    },
    listCar() {
      this.$token_api
        .get("/list-car-data")
        .then((res) => {
          this.desserts = res.data.data;
          //console.log(res.data.data);
        })
        .catch((err) => {});
    },
    initialize() {
      this.listCar();
    },
    edit_carrier(item) {
      // console.log(
      //   item.CAR_BRAND,
      //   item.CAR_GENERATION,
      //   item.CAR_ID,
      //   item.CAR_NUMBER,
      //   item.CAR_TYPE
      // );
      let car_update = {
        CAR_NUMBER:item.CAR_NUMBER ,
        CAR_TYPE:item.CAR_TYPE ,
        CAR_BRAND:item.CAR_BRAND ,
        CAR_GENERATION:item.CAR_GENERATION ,
        AUTO_ID:item.AUTO_ID 
      };
      // console.log(car_update);
      // this.$token_api
      //   .post("/update-car",car_update)
      //   .then((res) => {
      //      this.$swal({
      //         title: "แก้ไขเรียบร้อย",
      //         timer: 2000,
      //         icon: "success",
      //       });
      //   })
      //   .catch((e) => {
      //     console.log(e);
          
      //     this.$swal(
      //       "กรุณาลองใหม่อีกครั้ง",
      //       "เกิดข้อผิดพลาด",
      //       "error"
      //     );
      //   });
    },
    delete_carrier(item) {
      this.$swal({
        title: "ลบข้อมูลรถ",
        text: `กรุณากดปุ่ม "ยีนยัน" เพื่อลบข้อมูล`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
      }).then((result) => {
        if (result.value) {
          //console.log(item.CAR_ID)
          //ยังลบไม่ได้ ติด FOREIGN KEY
          this.$token_api
            .delete("/delete-car", { data: { CAR_ID: item.CAR_ID } })
            .then((response) => {
              // console.log(response.data);
              this.$store.dispatch("Carrier/car_reset");
              this.listCar();
            })
            .catch((err) => {
              console.log(err);
            });
        }
      });
      // if (item[0]) {
      //   this.$token_api
      //     .post("/delete-car", item[0])
      //     .then((response) => {
      //       console.log(response.data);
      //       this.$store.dispatch("Carrier/car_reset");
      //     })
      //     .catch((err) => {});
      // } else {
      //   this.$swal(
      //     "กรุณากรอกข้อมูลให้ถูกต้องครบถ้วน",
      //     "เกิดข้อผิดพลาด",
      //     "error"
      //   );
      // }
    },
  },
};
</script>